import { gsapScramble } from "../utils/scrambleText";

export default function initRadarAnimation() {
  const containers = document.getElementsByClassName('radar-animation');

  for (let i = 0; i < containers.length; i++) {
    const container = containers[i];

    // Dots
    const dots = container.getElementsByClassName('radar-dot');

    Array.from(dots).forEach(dot => {
      // Set CSS transition for a smooth blink effect
      dot.style.transition = 'fill 0.4s ease-in-out, opacity 0.4s ease-in-out';

      const animateDot = () => {
        const random = Math.random();

        if (random < 0.02) {
          // 10% chance: red with 1 opacity
          dot.style.fill = '#c30000';
          dot.style.opacity = '1';
        } else if (random < 0.08) {
          // 20% chance: green with 1 opacity
          dot.style.fill = '#00C3A6';
          dot.style.opacity = '1';
        } else {
          // 70% chance: green with 0.15 opacity
          dot.style.fill = '#00C3A6';
          dot.style.opacity = '0.15';
        }

        // Schedule next state change at random intervals between 1 and 5 seconds
        const nextBlink = 1_000 + Math.random() * 4_000;
        setTimeout(animateDot, nextBlink);
      };

      // Randomize initial start time to make the dots animate asynchronously
      setTimeout(animateDot, Math.random() * 5_000);
    });
  }

  // --- Scrambled numbers: appear randomly, show for a while, disappear ---
  const numberSpans = document.querySelectorAll('.scrambled-data .number');

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function scheduleNumber(span) {
    // Pick a random digit length between 4 and 9
    const digitLen = randomInt(3, 5);
    const min = Math.pow(10, digitLen - 1);
    const max = Math.pow(10, digitLen) - 1;
    const newValue = randomInt(min, max).toString();

    // 30% chance to be bigger
    const bigger = Math.random() < 0.5;
    span.classList.toggle('text-bigger', bigger);

    // Set the new value and scramble chars
    span.textContent = newValue;
    span.dataset.animateFrom = randomInt(min * 10, max * 10).toString();

    // Fade in
    span.style.transition = 'opacity 0.5s ease';
    span.style.opacity = '1';

    gsapScramble(span);

    // Stay visible for 2s–5s, then fade out and restart
    const visibleDuration = 2_000 + Math.random() * 3_000;
    setTimeout(() => {
      span.style.opacity = '0';

      // Schedule next appearance after it fades out
      scheduleNumber(span);
    }, visibleDuration);
  }

  // Stagger initial start times so they don't all pop up at once
  numberSpans.forEach((span, index) => {
    setTimeout(() => scheduleNumber(span), index * 1_200 + Math.random() * 800);
  });
}
